import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { DetalleProveedoresComponent } from '../../detalle-proveedores/detalle-proveedores.component';
import { DialogInformationComponent } from 'src/app/shared/components/dialog-information/dialog-information.component';
import { Constanst } from 'src/app/core/constants/constans.component';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-detalle-equipos',
  templateUrl: './detalle-equipos.component.html',
  styleUrls: ['./detalle-equipos.component.css'],
  providers: [DatePipe, DecimalPipe]
})
export class DetalleEquiposComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  equipmentForm: FormGroup;

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  supplierExists: boolean = false;
  urlImage: string = '';
  urlPDF: string = '';
  statusPdf: boolean = true;
  specification: string = '';
  statusSpecification: boolean = true;
  description: string = '';
  reference: string = '';
  botonPdf: boolean = this.data.simple;

  nroRegistros: number = this.data.nroRegistro;
  dialogTitle: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogDetalleProveedor: MatDialog,
    private apiCallService: ApiCallService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    public dialogModalGeneric: MatDialog,
    public dialogSpecification: MatDialog,
    public dialogDetalleEquipoRef: MatDialogRef<DetalleEquiposComponent>,
    private helperClassService: HelperClassService
  ) { }

  ngOnInit(): void {
    this.dialogTitle = this.data.dialogTitle;
    this.consultEquipmentDetails();

    this.equipmentForm = new FormGroup ({
      reference: new FormControl({value: '', disabled: true}),
      date: new FormControl({value: '', disabled: true}),
      description: new FormControl({value: '', disabled: true}),
      precio: new FormControl({value: '', disabled: true}),
      cop: new FormControl({value: '', disabled: true}),
      costoDiario: new FormControl({value: '', disabled: true}),
      copDate: new FormControl({value: '', disabled: true}),
      ivaExento: new FormControl({value: '', disabled: true}),
      relateDollar: new FormControl({value: '', disabled: true}),
      dollarCostPrice: new FormControl({value: '', disabled: true}),
      contributesVan: new FormControl({value: '', disabled: true}),
      addedValue: new FormControl({value: '', disabled: true}),
      commentary: new FormControl({value: '', disabled: true}),
      equipmentGroupingEntity: new FormControl({value: '', disabled: true}),
      urlImage: new FormControl({value: '', disabled: true}),
      proveedor: new FormGroup ({
        referencia: new FormControl({value: '', disabled: true}),
        razonSocial: new FormControl({value: '', disabled: true}),
        contacto: new FormControl({value: '', disabled: true}),
        actividad: new FormControl({value: '', disabled: true}),
        especialidad: new FormControl({value: '', disabled: true}),
        direccion1: new FormControl({value: '', disabled: true}),
        direccion2: new FormControl({value: '', disabled: true}),
        telefono: new FormControl({value: '', disabled: true}),
        fax: new FormControl({value: '', disabled: true}),
        email: new FormControl({value: '', disabled: true}),
        web: new FormControl({value: '', disabled: true}),
        comentario: new FormControl({value: '', disabled: true}),
      })
    })
  }

  consultEquipmentDetails() {
    this.route = '/getEquipmentDetailById';
    this.method = 'POST';

    let data = {
      idEquipment: this.data.row.idEquipment,
      idEquipmentZone: this.data.row.idEquipmentZone
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
    .pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        //console.log(response);
        if(response.data.equipmentZoneEntity.supplierEntity) {
          this.supplierExists = true;
        }
        this.equipmentForm = new FormGroup ({
          reference: new FormControl({value: response.data.equipmentEntity.reference, disabled: true}),
          date: new FormControl({value: this.datePipe.transform(response.data.equipmentEntity.updateDate, 'dd/MM/yyyy'), disabled: true}),
          description: new FormControl({value: response.data.equipmentEntity.description, disabled: true}),
          precio: new FormControl({value: this.decimalPipe.transform(response.data.equipmentZoneEntity.price, '1.2-2'), disabled: true}),
          cop: new FormControl({value: this.decimalPipe.transform(response.data.equipmentEntity.depreciationCOP, '1.6-6'), disabled: true}),
          costoDiario: new FormControl({value: this.decimalPipe.transform(response.data.equipmentZoneEntity.price * response.data.equipmentEntity.depreciationCOP, '1.2-2'), disabled: true}),
          copDate: new FormControl({value: this.datePipe.transform(response.data.equipmentEntity.dateCOP, 'dd/MM/yyyy'), disabled: true}),
          ivaExento: new FormControl({value: '', disabled: true}),
          relateDollar: new FormControl({value: response.data.equipmentEntity.relateDollar, disabled: true}),
          dollarCostPrice: new FormControl({value: this.decimalPipe.transform(response.data.equipmentEntity.dollarPrice, '1.2-2'), disabled: true}),
          contributesVan: new FormControl({value: response.data.equipmentEntity.contributesVan, disabled: true}),
          addedValue: new FormControl({value: this.decimalPipe.transform(response.data.equipmentEntity.addedValue, '1.2-2'), disabled: true}),
          commentary: new FormControl({value: '', disabled: true}),
          equipmentGroupingEntity: new FormControl({value: response.data.equipmentEntity.equipmentGroupingEntity ? response.data.equipmentEntity.equipmentGroupingEntity.group : '', disabled: true}),
          urlImage: new FormControl({ value: response.data.equipmentEntity.urlImage ? response.data.equipmentEntity.urlImage : Constanst.IMG_EQUIPMENT_NOT_AVAILABLE, disabled: true }),
          proveedor: new FormGroup ({
            referencia: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.supplierCode : '', disabled: true}),
            razonSocial: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.supplierName : '', disabled: true}),
            contacto: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.contact : '', disabled: true}),
            actividad: new FormControl({value: (response.data.equipmentZoneEntity.supplierEntity && response.data.equipmentZoneEntity.supplierEntity.activityEntity) ?
              response.data.equipmentZoneEntity.supplierEntity.activityEntity.activityName : '', disabled: true}),
            especialidad: new FormControl({value: (response.data.equipmentZoneEntity.supplierEntity && response.data.equipmentZoneEntity.supplierEntity.specialtyEntity) ?
              response.data.equipmentZoneEntity.supplierEntity.specialtyEntity.specialtyName : '', disabled: true}),
            direccion1: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.address1 : '', disabled: true}),
            direccion2: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.address2 : '', disabled: true}),
            telefono: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.phone : '', disabled: true}),
            fax: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.fax : '', disabled: true}),
            email: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.email : '', disabled: true}),
            web: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.web : '', disabled: true}),
            comentario: new FormControl({value: response.data.equipmentZoneEntity.supplierEntity ? response.data.equipmentZoneEntity.supplierEntity.commentary : '', disabled: true}),
          })

        })
        this.urlImage = response.data.equipmentEntity.urlImage ? response.data.equipmentEntity.urlImage : Constanst.IMG_EQUIPMENT_NOT_AVAILABLE;
        if (response.data.equipmentEntity.urlPdf) {
          this.urlPDF = response.data.equipmentEntity.urlPdf;
          this.statusPdf = false;
        }
        if (response.data.equipmentEntity.specification) {
          this.specification = response.data.equipmentEntity.specification;
          this.statusSpecification = false;
        }
        this.description = response.data.equipmentEntity.description;
        this.reference = response.data.equipmentEntity.reference;
        this.apiCallService.hideSpinner();
      });

    }

    openProviderDetails(provider: any) {
      const dialog = this.dialogDetalleProveedor.open(DetalleProveedoresComponent, {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        // disableClose: true,
        data: {provider}
      });
    }

    openPDF(fileUrl: string) {
      this.helperClassService.validateDocumentExists(fileUrl).subscribe(existe => {
        if (existe) {
          window.open(fileUrl, '_blank');
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_DOCUMENT_NOT_AVAILABLE, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      });
    }

    openSpecification(specification: string) {
      const dialog = this.dialogSpecification.open(DialogInformationComponent, {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        data: {specification, reference: this.reference, description: this.description}
      });
    }

  closeDialogDetalleEquipo() {
    this.dialogDetalleEquipoRef.close();
  }

}
